export const REGISTER_API_PATH = "register/new-account";

export const LOGIN_API_PATH = "login";
export const AUTH_USER_API_PATH = "auth_user";

export const SETTINGS_API_PATH = "settings";
export const GET_SETTINGS_API_PATH = `${SETTINGS_API_PATH}`;
export const EDIT_SETTINGS_API_PATH = `${SETTINGS_API_PATH}/edit`;

export const ACCOUNT_API_PATH = "account";
export const GET_ACCOUNT_API_PATH = `${ACCOUNT_API_PATH}`;
export const EDIT_ACCOUNT_API_PATH = `${ACCOUNT_API_PATH}/edit`;
export const ACCOUNT_BASIC_USAGE_STATS = `${ACCOUNT_API_PATH}/usage-stats`;
export const API_KEY_API_PATH = `${ACCOUNT_API_PATH}/api-key`;

export const USAGE_HISTORY = "usage-history";
export const GET_USAGE_HISTORY_API_PATH = `${USAGE_HISTORY}/full-history`;

export const USERS_API_PATH = "user";
export const GET_ALL_USERS_API_PATH = `${USERS_API_PATH}/all`;
export const GET_ALL_FILTERED_USERS_API_PATH = `${USERS_API_PATH}/all-filtered`;
export const GET_SINGLE_USER_API_PATH = `${USERS_API_PATH}?id={userId}`;
export const ADD_USERS_API_PATH = `${USERS_API_PATH}/add-user-to-current-account`;
export const EDIT_USER_API_PATH = `${USERS_API_PATH}/edit?id={userId}`;
export const DELETE_USER_API_PATH = `${USERS_API_PATH}?id={userId}`;

export const FRONTEND_METRICS_API_PATH = "frontend-metrics";
export const LOG_FRONTEND_API_ERROR_API_PATH = `${FRONTEND_METRICS_API_PATH}/log-frontend-error`;

export const BACKGROUND_REMOVE_FUNCTIONALITY_API_PATH = "background-remove";
export const REMOVE_BACKGROUND_API_PATH = `${BACKGROUND_REMOVE_FUNCTIONALITY_API_PATH}/remove-background`;